import { AuthContext, useAuthContext } from 'contexts/authContext';
import React from 'react';
import { Navigate, useNavigate } from "react-router-dom";

export const PrivateRoute = ({ roles, inAllRoles, children }: any) => {

    const { loading, isAuthenticated, checkAuth } = useAuthContext();
    const navigate = useNavigate();

    React.useEffect(() => {
        if (loading && !isAuthenticated()) {
            // user is not authenticated
            navigate('/login', { replace: true });
            return;
        }

        if (inAllRoles === undefined || inAllRoles === null) {
            if (loading && !checkAuth(roles, false)) {
                // user is not authorized
                navigate('/unauthorized', { replace: true });
                return;
            }
        }
        else {
            if (loading && !checkAuth(roles, inAllRoles)) {
                // user is not authorized
                navigate('/unauthorized', { replace: true });
                return;
            }
        }

    })

    return (
            children
    )
};
